
import {ElLoading} from "element-plus";

type column = {
    prop: String;
    label: String;
    width: Number;
};

type parts = {
    name: string;
    mountings_type_pname: string;
    mountings_type_name: string;
    cost_price: number | null;
    selling_price: number | null;
    price_lock: number;
    mountings_brand_name: string;
    specification: string;
    mountings_unit_name: string;
    build_bonus_type: number;
    build_bonus_price: number | null;
    sell_bonus_type: number;
    sell_bonus_price: number | null;
    reappearance_type_name: string;
    describe: string;
    id: number;
};
type partsKey = keyof parts;
type formKey = keyof partsFormType;
let columnList: Array<column> = [

    
    {
        prop: "create_time_text",
        label: "创建时间",
        width: 75,
    },
    {
        prop: "toexamine",
        label: "状态",
        width: 65,
    },
    {
        prop: "expenditure_price",
        label: "金额",
        width: 65,
    },
    {
        prop: "pay_type_text",
        label: "付款方式",
        width: 65,
    },
    {
        prop: "expenditure_payer",
        label: "收款方",
        width: 75,
    },
    {
        prop: "admin",
        label: "经手人",
        width: 75,
    },
    {
        prop: "branch",
        label: "成本承担部门",
        width: 75,
    },
    {
        prop: "expenditure_desc",
        label: "备注",
        width: 75,
    }
];
const purchaseColumn: Array<column> = [
    {
        prop: "name",
        label: "配件名称",
        width: 120,
    },
    {
        prop: "specification",
        label: "规格",
        width: 120,
    },
    {
        prop: "encoding",
        label: "编码",
        width: 80,
    },
    {
        prop: "mountings_type_p_name",
        label: "配件分类",
        width: 80,
    },
    {
        prop: "mountings_brand_name",
        label: "品牌",
        width: 80,
    },
    {
        prop: "mountings_unit_name",
        label: "单位",
        width: 80,
    },
    {
        prop: "cost_price",
        label: "采购单价",
        width: 80,
    },
    {
        prop: "member",
        label: "数量",
        width: 80,
    },
    {
        prop: "total_price",
        label: "金额",
        width: 80,
    },
];

import {
    defineComponent,
    ref,
    reactive,
    inject,
    provide,
    onMounted,
    watch,
} from "vue";
import {
    getManagementTable,
    getManagementTableAdd,
    getManagementTableEdit,
    getSetManagement,
    getSelectList, getBasicsetList, purchaseCopeExport, expenditureExport, permissionList, getPurchaseInfo,
} from "@/api/http";



import {Request} from '@/api/request';
import { validateInput, validateClass } from "@/assets/js/formRules";
import { partsFormType } from "@/assets/types/common";
import { useRoute, useRouter } from 'vue-router'
export default defineComponent({
    name: "expenditureList",
    setup() {
        const setTitle: any = inject("setTitle");
        setTitle(['支出记账']);
   
        const headClass = inject("headClass");
        let pageSize = ref(10),
            currentPage = ref(1),
            tableData = ref([] as Array<any>),
            total = ref(0),
            loading = ref(true),
            roleList = ref({} as any),
            type =  ref(''),
            route:any = useRoute(),
            Router:any = useRouter(),
            //采购详情
            purchaseDetail = ref([] as any),
            isMountings = ref(false),
            dialogFormVisible = ref(false),
            detailTable = ref([] as Array<any>),
            // 筛选
            selectGroup = reactive({
                status: "",
                build_bonus_price: "",
                return_cash_plan: "",
                mountings_type_pname: "",
                mountings_type_name: "",
                mountings_brand_name: "",
                search:''
            }),
            selectList = ref({
                type: [],
                zf: [],
                specialType: [],
                specialZf: [],
                staff: [],
                branch: [],
                expenditureType:[],
              totalPrice:null
            }),
            remote_loading = ref(false),
            getFirstNowLastDay = ():Array<number> => {
                let now = new Date();
                let strLink = "/";
                let year = now.getFullYear();
                let month:any = now.getMonth() + 1;
                let day:any = now.getDate();
                // if (month >= 1 && month <= 9) {
                //   month = "0" + month;
                // }
                // if (day >= 1 && day <= 9) {
                //   day = "0" + day;
                // }
                let firstDate:string = year + strLink + month + strLink + '1';
                let currentDate = year + strLink + month + strLink + day;
                //var lastDay = this.getLastDay(year, month);
                //var lastDate = year + strLink + month + strLink + lastDay;
                return [new Date(firstDate).getTime(),new Date(currentDate).getTime()];
            },
            screenParameter = ref({
                time: [getFirstNowLastDay()[0],getFirstNowLastDay()[1]],
                start_time: null,
                end_time: null,
                search: '',
                page: currentPage.value,
                pagesize: pageSize.value,
                type: 1,
                income_type: null,
                status: null,
                income_collection: null,
                store_id: null,
                branch_id:null
            } as any),
            dialog_model = ref(''),
            dialog_load = ref(false),
            dialogTitle = ref("新增配件"),
            form_rules:any = {
                //expenditure_time expenditure_type_id branch_id expenditure_price pay_type
				expenditure_time: {required: true, message: '必填', trigger: 'blur'},
                expenditure_type_id: {required: true, message: '必填', trigger: 'blur'},
                branch_id: {required: true, message: '必填', trigger: 'blur'},
                expenditure_price: {required: true, message: '必填', trigger: 'blur'},
                pay_type: {required: true, message: '必填', trigger: 'blur'},
			},
            dialog_index = 0,
            formRef = ref(null),
            form = ref({} as any),
            isEdit = ref(false);
        let handleSizeChange = (size: number): void => {
                pageSize.value = size;
                getTableData();
            },
            handleCurrentChange = (page: number): void => {
                currentPage.value = page;
                getTableData();
            },
            changeIncome = (type: number, index: number) => {
                if (type == 1) {
                    dialog_model.value = 'add';
                } else {
                    dialog_model.value = 'edit';
                    form.value = {
                        expenditure_id:Number(tableData.value[index].expenditure_id),
                        expenditure_type_id: Number(tableData.value[index].expenditure_type_id),
                        expenditure_time_text: tableData.value[index].expenditure_time_text,
                        expenditure_time: tableData.value[index].expenditure_time,
                        expenditure_price: tableData.value[index].expenditure_price,
                        pay_type: Number(tableData.value[index].pay_type),
                        expenditure_payer: tableData.value[index].expenditure_payer,
                        expenditure_phone: tableData.value[index].expenditure_phone,
                        admin_id: tableData.value[index].admin_id,
                        expenditure_desc: tableData.value[index].expenditure_desc,
                        branch_id: tableData.value[index].branch_id,
                    };
                }
        
            },
            getSummaries1 = (param: any, type: number): Array<string> => {
                const { columns, data } = param;
                const sums: any = [];
                const propArr = [
                    "total_price",
                    "member",
                ];
                columns.forEach((column: any, index: number) => {
                    if (index === 0) {
                        sums[index] = "";
                        return;
                    }
                    const values = data.map((item: any) =>
                        Number(item[column.property])
                    );
                    if (
                        propArr.findIndex((item: any) => {
                            return item == column.property;
                        }) > -1
                    ) {
                        // 增加合计项
                        switch (type) {
                            // 配件合计
                            case 1:
                                if (column.property == "total_price") {
                                    sums[index] = purchaseDetail.value.total_price;
                                } else {
                                    sums[index] = purchaseDetail.value.number;
                                }
                                break;
                        }
                        if(column.property == "member"){
                            sums[index] = `${sums[index]}`;
                        }else{
                            sums[index] = `¥${sums[index]}`;
                        }
                    } else {
                        sums[index] = "";
                    }
                });
                return sums;
            },
            // 点击采购单据编号触发
            bindPurchaseInfo = (purchaes_number: string) => {
                getPurchaseInfo({ purchaes_number }).then((res: any) => {
                    if (res.status == 200) {
                        let info = res.content.list;
                        if(info) {
                            let arr = [[
                                '单据编号',
                                info.purchaes_number,
                                '状态',
                                info.toexamine,
                                '单据日期',
                                info.purchase_time_text,
                                '供应商',
                                info.supplier,
                            ],[
                                '制单时间',
                                info.create_time_text,
                                '制单人',
                                info.preparer_text,
                                '审核时间',
                                info.toexamine_time_text,
                                '审核人',
                                info.reviewer_text,
                            ],[
                                '采购员',
                                info.employee_text,
                                '采购类型',
                                info.purchase_type_name,
                                '关联单据',
                                info.purchaes_bill,
                                '实际采购单号',
                                info.purchase_sh,
                            ],[
                                '备注',
                                info.purchase_desc,
                            ]];
                            detailTable.value = arr;
                            purchaseDetail.value = res.content.list;
                            dialogFormVisible.value = true;
                            if(res.content.list.data.length > 0){
                                isMountings.value = true
                            }
                        }
                    }
                });
            },
            getTableData = (): void => {
                loading.value = true;
                let mydata = {
                    type:1,
                    role_name:'expenditureList',
                };
                permissionList(mydata).then((res:any)=>{
                    roleList.value = res?.content?.list || 0;
                });
                let start_time = screenParameter.value.time?Math.floor(new Date(screenParameter.value.time[0]).getTime()/1000):"";
                let end_time = screenParameter.value.time ?Math.floor((new Date(screenParameter.value.time[1]).getTime()+24*60*60*1000-1)/1000):"";
                Request.axiosInstance({
                    url: 'adminapi/Bookkeeping/expenditureList',
                    data: {
                        ...screenParameter.value,
                        page: currentPage.value,
                        pagesize: pageSize.value,
                        start_time:start_time,
                        end_time:end_time
                    }
                }).then((res: any) => {
                    tableData.value = res?.content?.list || [];
                    loading.value = false;
                    total.value = res?.content?.total || 0;
                    selectList.value.totalPrice = res?.content?.price_total;
                })

            },
            exportChange = () => {
                const loading = ElLoading.service({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)',
                });
                let start_time = screenParameter.value.time?Math.floor(new Date(screenParameter.value.time[0]).getTime()/1000):"";
                let end_time = screenParameter.value.time ?Math.floor((new Date(screenParameter.value.time[1]).getTime()+24*60*60*1000-1)/1000):"";
                expenditureExport({
                    ...screenParameter.value,
                    start_time:start_time,
                    end_time:end_time
                }).then((res: any) => {
                    loading.close();
                    if (res.status == 200) {
                        const url = res.content;
                        window.open(url);
                    }
                }).catch(()=>{
                    loading.close();
                });
            },
            getSelectData = (data: {
                search?: string;
                type_pid?: number | null;
            }) => {
                getSelectList(data).then((res: any) => {
                    Object.assign(selectList.value, res?.content || {});
                    remote_loading.value = false;
                });
            },
            getSummaries = (param: any): Array<string> => {
              const {columns, data} = param;
              const sums: any = [];
              const propArr = [
                "expenditure_price"
              ];
              columns.forEach((column: any, index: number) => {
                if (index === 0) {
                  sums[index] = "合计";
                  return;
                }
                const values = data.map((item: any) =>
                    Number(item[column.property])
                );
                if (
                    propArr.findIndex((item: any) => {
                      return item == column.property;
                    }) > -1
                ) {
                  // 增加合计项
                  if (column.property == "expenditure_price") {
                      sums[index] = selectList.value.totalPrice;
                  }
                } else {
                  sums[index] = "";
                }
              });
              return sums;
            },
            selectChange = (e: any, key: string): void => {
                currentPage.value = 1;
                getTableData();
            },
            remoteBrand = (e: string) => {
                remote_loading.value = true;
                getSelectData({ search: e });
            },
            formSelectChange = (e: number) => {
                getSelectData({ type_pid: e });
                form.value.mountings_type_id = null;
            },
            bonusSelectChange = (type: boolean) => {
                if (type) {
                    form.value.build_bonus_price = null;
                } else {
                    form.value.sell_bonus_price = null;
                }
            },
            brandBlur = (type: boolean) => {
                if (type) {
                    if (!selectGroup.mountings_brand_name) {
                        getSelectData({});
                    }
                } else {
                    if (!form.value.mountings_brand_id) {
                        getSelectData({});
                    }
                }
            },
            screenChange = (e: any, key: string): void => {

              if (key == "time") {
                  if (e){
                      //screenParameter.value["start_time"] = e ? (e[0] as Date).getTime() / 1000 : null
                      //screenParameter.value["end_time"] = e ? (e[1] as Date).getTime() / 1000 : null
                  }else{
                      screenParameter.value["type"] = "";
                  }
                  currentPage.value = 1;
                getTableData();
              }
              if(key == 'formtime'){
                  form.value["expenditure_time_text"] = e
                  form.value["expenditure_time"] = e ? (e as Date).getTime() / 1000 : null
              }

            },

            _option = (url: string , data: any) => {
				Router.push({
					path: url,
					query: data
				})
			},

            _incomeUpstar = (id: Number, type: Number) =>{

                Request.axiosInstance({
                    url: 'adminapi/Bookkeeping/expenditureUpstate',
                    data: {expenditure_id: id, type }
                }).then((res: any) => {
                    res.status == 202 && getTableData()
                })

            },
             _form_submit = () => {
                (formRef.value as any).validate((valid: boolean) => {
                    if (!valid)  return
                    dialog_load.value = true;
                    if (dialog_model.value == 'edit'){
                        Request.axiosInstance({
                            url: 'adminapi/Bookkeeping/editExpenditure',
                            data: form.value
                        }).then((res) => {
                            dialog_load.value = false
                            if (res.status != 202) return
                            dialog_model.value = ''
                            getTableData()
                        })
                    }else {
                        Request.axiosInstance({
                            url: 'adminapi/Bookkeeping/expenditureCreate',
                            data: form.value
                        }).then((res) => {
                            dialog_load.value = false
                            if (res.status != 202) return
                            dialog_model.value = ''
                            getTableData()
                        })
                    }
                });
            }


        onMounted(() => {

          Promise.all([
            Request.axiosInstance({
              url: 'adminapi/Bookkeeping/expenditureType',
              data: {status: 1}
            }),
            Request.axiosInstance({
              url: 'adminapi/Basicset/totalList',
              data: {basicset_type: 3}
            }),
            Request.axiosInstance({
              url: 'adminapi/OrderCar/constructors',
              data: {}
            }),
            getBasicsetList({basicset_type: 5}),
              Request.axiosInstance({
                  url: 'adminapi/Basicset/specialTotalList',
                  data: {basicset_type: 5}
              }),
              Request.axiosInstance({
                  url: 'adminapi/Basicset/specialTotalList',
                  data: {basicset_type: 3}
              }),

          ]).then((res: any) => {
            console.log(res)
            selectList.value.type = res[0]?.content?.list
            selectList.value.zf = res[1]?.content?.list
            selectList.value.staff = res[2]?.content?.staff
            selectList.value.branch = res[2]?.content?.branch
            selectList.value.expenditureType = res[3]?.content?.list
              selectList.value.specialType = res[4]?.content?.list
              selectList.value.specialZf = res[5]?.content?.list
          })
          getTableData();
        });

        watch(dialog_model, (newval: any, oldval: any) => {
            if(newval == 'add'){
                form.value = {
                    expenditure_time: new Date().getTime() / 1000,
                    expenditure_time_text:new Date(),
                    expenditure_price: null,
                    expenditure_desc: null,
                    expenditure_type_id: null,
                    admin_id: null,
                    pay_type: null,
                    expenditure_phone: null,
                    expenditure_payer: null,
                    branch_id: null
                }
                dialog_load.value = false;
                (formRef.value as any)?.resetFields();
            }

        })

        return {
            columnList,
            headClass,
            pageSize,
            currentPage,
            tableData,
            total,
            loading,
            selectGroup,
            selectList,
            remote_loading,
            dialogTitle,
            formRef,
            form,
            isEdit,
            handleSizeChange,
            handleCurrentChange,
            selectChange,
            remoteBrand,
            formSelectChange,
            bonusSelectChange,
            brandBlur,
            type,
            _option,
            screenParameter,
            dialog_model,
            screenChange,
            _incomeUpstar,
            dialog_index,
            form_rules,
            _form_submit,
          getSummaries,
            exportChange,
            roleList,
            changeIncome,
        purchaseDetail,
            isMountings,
            dialogFormVisible,
            detailTable,
            getSummaries1,
            bindPurchaseInfo,
            purchaseColumn
        };
    },
});
